module.exports = __webpack_public_path__ + "img/googleslide-addin-03.73dcb963.png";